export type MenuColumn = {
  heading: string;
  items: { label: string; path: string }[];
};

export type MenuItem = {
  key: string;
  label: string;
  columns: MenuColumn[];
  hideInDesktop?: boolean;
};

export const menuData: MenuItem[] = [
 
  {
    key: "services",
    label: "Services",
    columns: [
      {
        heading: "Core & Enterprise",
        items: [
          { label: "AI & Intelligent Automation", path: "/ai-intelligent-automation" },
          { label: "Industrial IoT", path: "/industrial-iot" },
          { label: "Data Engineering & Analytics", path: "/data-engineering-analytics" },
          { label: "Software Engineering", path: "/software-engineering" },
          { label: "Enterprise Applications", path: "/Enterprise-Applications" },
          { label: "Cloud & Devops Engineering", path: "/cloud-devops-engineering" },
        ]
      },
      {
        heading: "Digital & Managed",
        items: [
          { label: "Mobile Development", path: "/mobile-development" },
          { label: "SaaS Development", path: "/saas-development" },
          { label: "QA & Test Automation", path: "/qa-test-automation" },
          { label: "UI/UX Engineering", path: "/ui-ux-engineering" },
          { label: "Digital Marketing", path: "/digital-marketing" },
          { label: "Managed Services", path: "/managed-services" },
        ]
      }
    ]
  },
  {
    key: "industries",
    label: "Industries",
    columns: [
      {
        heading: "Industries We Serve",
        items: [
          { label: "Manufacturing", path: "/manufacturing" },
          { label: "Healthcare", path: "/healthcare" },
          { label: "Retail & Ecommerce", path: "/retail-ecommerce" },
          { label: "Logistics", path: "/logistics" },
          { label: "Government", path: "/government" },
          { label: "Waste Management & Recycling", path: "/waste-management-recycling" },
          { label: "Financial Services", path: "/financial-services-fintech" },
          { label: "Hospitality", path: "/hospitality" },
        ]
      }
    ]
  },
  {
    key: "engagement-models",
    label: "Engagement Models",
    columns: [
      {
        heading: "Engagement Models",
        items: [
           { label: "Offshore Development Center", path: "/offshore-development-center" },
          { label: "AI & IoT Consulting", path: "/ai-iot-consulting" },
          { label: "Dedicated Engineering Teams/Pods", path: "/dedicated-engineering-teams" },
          { label: "Staff Augmentation", path: "/staff-augmentation" },
          // { label: "Time & Material (T&M)", path: "/time-material" },
        ]
      }
    ]
  },
    {
    key: "case-studies",
    label: "Case Studies",
    columns: [

      {
        heading: "Enterprise Systems",
        items: [
          { label: "Manufacturing ERP & Operations Platform", path: "/case-studies/manufacturing-erp-transformation" },
          { label: "Supply Chain & Manufacturing ERP Platform", path: "/case-studies/hrms-automation-platform" },
          { label: "Field Sales Tracking & Distribution Automation", path: "/case-studies/business-workflow-automation" },
          { label: "Freight Booking & Logistics Platform", path: "/case-studies/enterprise-analytics-dashboard" },
          { label: "Ride-Hailing Platform", path: "/case-studies/Ride-Hailing-Platform" },
          { label: "Multi-Vehicle Logistics & Delivery Platform", path: "/case-studies/Multi-Vehicle-Logistics-Delivery-Platform" },
          { label: "Enterprise Multi-Website Infrastructure & Managed Support", path: "/case-studies/multi-website-infrastructure-management" },
        ]
      },
      {
        heading: "AI & Automation",
        items: [
          { label: "AI-Powered Personalized Health Platform", path: "/case-studies/ai-healthcare-platform-usa" },
          { label: "AI Sales Engagement & Email Intelligence Platform", path: "/case-studies/enterprise-ai-assistant" },
          { label: "AI-Powered Learning Experience Platform", path: "/case-studies/ai-powered-lms-platform" },
          { label: "Enterprise Learning & Coding Platform", path: "/case-studies/ai-document-intelligence-system" },
          { label: "AI-Powered Identity Verification Platform", path: "/case-studies/AI-Powered-Identity-Verification-Platform" },
        ]
      },
     
      {
        heading: "Product Engineering",
        items: [
          { label: "Founder Networking & Community Platform", path: "/case-studies/saas-ecosystem-australia" },
          { label: "Government Digital Marketplace Platform", path: "/case-studies/multi-tenant-enterprise-platform" },
          { label: "Custom E-Commerce Platform", path: "/case-studies/cloud-product-modernization" },
          { label: "Print E-Commerce Platform", path: "/case-studies/enterprise-mobile-platform" },
        ]
      },

       {
        heading: "Industrial IoT",
        items: [
          { label: "Smart Asset & IoT Management Platform", path: "/case-studies/smart-factory-monitoring-platform" },
          { label: "Connected Industrial IoT Maintenance Platform", path: "/case-studies/industrial-erp-iot-ecosystem" },
        ]
      },
      
    ]
  },
  {
    key: "company",
    label: "Company",
    columns: [
      {
        heading: "Company",
        items: [
          { label: "About Santhila", path: "/about-us" },
          { label: "Leadership", path: "/board-of-directors" },
          { label: "Why Santhila", path: "/why-us" },
          { label: "Testimonials", path: "/testimonials" },
          // { label: "Global Delivery", path: "/global-delivery" },
          
        ]
      },
      {
        heading: "Connect",
        items: [
          { label: "Blog", path: "/blogs" },
          { label: "Careers", path: "/career" },
          { label: "Contact Us", path: "/contact" },
        ]
      }
    ]
  },
];

export default menuData;